import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import style from '../calender.module.scss';
import CalenderInput from '../CalenderInput';

function PLTimePicker({ value, placeholder, inputIcon, onSelected }) {
  const [selectedTime, setSelectedTime] = useState(null);

  function handleTimeChange(date) {
    setSelectedTime(date);
    const formattedTime = format(date, 'HH:mm:ss');
    onSelected(formattedTime);
  }

  useEffect(() => {
    if (value) {
      // value is a string like "12:30:00"
      const [hours, minutes, seconds] = value.split(':').map(Number);
      const today = new Date();
      today.setHours(hours, minutes || 0, seconds || 0, 0);
      setSelectedTime(today);
    }
  }, [value]);

  return (
    <div className={style.calenderContainer}>
      <DatePicker
        selected={selectedTime}
        onChange={date => handleTimeChange(date)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeCaption="Select Time"
        dateFormat="h:mm aa"
        popperPlacement="top-end"
        customInput={<CalenderInput placeholderText={placeholder} value={value} icon={inputIcon} />}
      />
    </div>
  );
}

PLTimePicker.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  inputIcon: PropTypes.string,
  onSelected: PropTypes.func,
};

export default PLTimePicker;
